import React from 'react';
import logo from './logo.svg';
import './App.css';

import MainComponent from './components/TabComponent';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MainComponent />
      </header>
    </div>
  );
}


export default App;
